export function Kids() {
  return (
    <section id="kids">
      <div className="container">
        <div className="section-head">
          <span className="section-tag">Voor kinderen 10-12 jaar</span>
          <h2>Bouw je eigen Simon Says memory-game</h2>
          <p>
            Drie uur Arduino, programmeren en solderen in een kleine groep. Aan het einde van
            de zaterdag speel je jouw eigen memory-game en neem je hem mee naar huis.
          </p>
        </div>

        <div className="price-banner" style={{ marginBottom: 56 }}>
          <div className="price-grid">
            <div>
              <span className="price-badge">We zijn aan het testen</span>
              <h3>Eerste edities — we kijken wie er geïnteresseerd is</h3>
              <p>
                Makers Hub is net van start. We draaien nu onze eerste zaterdagworkshops om het
                concept te testen en te kijken welke gezinnen interesse hebben. Schrijf je in
                voor een plek, of laat je e-mail achter om op de hoogte te blijven.
              </p>
              <p className="price-fineprint">
                Feedback van deze eerste deelnemers bepaalt hoe we verder gaan — welke
                projecten we aanbieden, welke zaterdagen, welke formules.
              </p>
            </div>
            <div className="price-calc">
              <div className="price-calc-title">Eén prijs, alles inbegrepen</div>
              <div className="price-row">
                <span className="label">Workshop 3u</span>
                <span>✓</span>
              </div>
              <div className="price-row">
                <span className="label">Alle componenten</span>
                <span>✓</span>
              </div>
              <div className="price-row">
                <span className="label">Werkend apparaat mee naar huis</span>
                <span>✓</span>
              </div>
              <div className="price-row final">
                <span className="label">Pilot-prijs</span>
                <span>
                  <s style={{ opacity: 0.55, fontWeight: 500, marginRight: 8 }}>€50</s>
                  €30
                </span>
              </div>
              <div className="price-calc-sub">
                Je hoeft enkel een laptop mee te brengen — wij zorgen voor de rest
              </div>
            </div>
          </div>
        </div>

        <div className="workshops">
          <div className="ws-card featured">
            <span className="ws-tag">Nu open</span>
            <h3>Simon Says Memory-Game</h3>
            <div className="ws-sub">
              Bouw een werkende arcade-memory game — 3 uur, één zaterdag
            </div>
            <div className="ws-price"><span className="orig">€50</span>€30</div>
            <div className="ws-price-sub">Pilot-prijs · incl. Elegoo Basic Starter Kit (t.w.v. €20) + werkend apparaat</div>
            <div className="ws-price-sub" style={{ marginTop: 4, fontStyle: "italic" }}>
              Volgende workshops: €10 (kit hergebruiken)
            </div>
            <ul className="ws-list">
              <li>Arduino &amp; breadboard intro</li>
              <li>4 gekleurde LEDs + knoppen aansluiten</li>
              <li>Buzzer voor geluidseffecten programmeren</li>
              <li>Memory-sequence code stap voor stap schrijven</li>
              <li>Klastoernooi: wie haalt het hoogste level?</li>
              <li>Werkende game mee naar huis</li>
            </ul>
            <a href="#inschrijven" className="btn btn-primary">
              Inschrijven workshop →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
